import { render, staticRenderFns } from "./manualAssignmentUpdate.vue?vue&type=template&id=4ad237bc&scoped=true"
import script from "./manualAssignmentUpdate.vue?vue&type=script&lang=js"
export * from "./manualAssignmentUpdate.vue?vue&type=script&lang=js"
import style0 from "./manualAssignmentUpdate.vue?vue&type=style&index=0&id=4ad237bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad237bc",
  null
  
)

export default component.exports